import { createApp } from 'vue'
import App from './App.vue'
import route from './router'
import store from './store'
import '../public/fa.css'
import '../public/yampi.css'
import httpClient from "@/services/HttpClient";
httpClient.setInterceptor();
createApp(App).use(store).use(route).mount('#app')
